{
  "unauthorized": {
    "errorCode": "403",
    "title": "Acc\u00e8s refus\u00e9",
    "subtitle": "Vous n\u2019avez pas la permission d\u2019acc\u00e9der \u00e0 cette page.",
    "backToChat": "Aller au chat",
    "helpText": "Si vous pensez qu\u2019il s\u2019agit d\u2019une erreur, veuillez contacter l\u2019administrateur de votre organisation."
  },
  "missionChat": {
    "agentNotRespondingDescription": "L'hôte « {{hostName}} » est connecté, mais l'environnement d'exécution de l'agent ne répond pas. Vérifiez que l'application de l'agent est en cours d'exécution sur l'hôte.",
    "hostOfflineDescription": "L'hôte d'agents « {{hostName}} » est actuellement hors ligne.",
    "accessDenied": "Accès refusé",
    "accessDeniedDescription": "Vous n'avez pas l'autorisation d'accéder à cette mission.",
    "agentNotResponding": "L'agent ne répond pas",
    "agentNotRespondingHint": "Vérifiez que l'agent agion-sdk est en cours d'exécution et écoute sur le port 8190.",
    "connectionError": "Erreur de connexion",
    "connectionErrorDescription": "Impossible de se connecter à la mission.",
    "error": "Une erreur s'est produite",
    "hostNotFound": "Hôte indisponible",
    "hostNotFoundDescription": "L'hôte d'agents de cette mission est introuvable.",
    "hostOffline": "Hôte hors ligne",
    "hostOfflineHint": "Vérifiez que l'hôte d'agents est en cours d'exécution et connecté au VPN.",
    "loadingHost": "Connexion à l'hôte...",
    "notFoundDescription": "Cette mission n'existe pas ou a peut-être été supprimée.",
    "retry": "Réessayer",
    "retryConnection": "Relancer la connexion",
    "launching": "Démarrage...",
    "runMission": "Lancer la mission",
    "loading": "Chargement du chat de mission...",
    "notFound": "Mission introuvable",
    "loadError": "\u00c9chec du chargement de la mission"
  },
  "files": {
    "title": "Fichiers",
    "subtitle": "G\u00e9rez vos fichiers et donn\u00e9es charg\u00e9s",
    "searchPlaceholder": "Rechercher des fichiers...",
    "count_one": "{{count}} fichier",
    "count_other": "{{count}} fichiers",
    "loading": "Chargement des fichiers...",
    "noFilesFound": "Aucun fichier trouv\u00e9",
    "noFilesUploaded": "Aucun fichier charg\u00e9",
    "adjustSearch": "Essayez d\u2019ajuster votre terme de recherche",
    "uploadFirst": "Chargez votre premier fichier pour commencer",
    "deleteConfirm": "\u00cates-vous s\u00fbr de vouloir supprimer ce fichier ?",
    "deleteSuccess": "Fichier supprim\u00e9 avec succ\u00e8s",
    "fileRemoved": "Fichier supprim\u00e9",
    "deleteError": "\u00c9chec de la suppression du fichier",
    "downloadError": "\u00c9chec du t\u00e9l\u00e9chargement du fichier",
    "downloadSuccess": "Fichier t\u00e9l\u00e9charg\u00e9 avec succ\u00e8s",
    "clickToRename": "Cliquer pour renommer le fichier",
    "referenceHint": "Les fichiers avec le statut \u00ab termin\u00e9 \u00bb peuvent \u00eatre r\u00e9f\u00e9renc\u00e9s dans le chat",
    "columnName": "Nom",
    "columnSize": "Taille",
    "columnDate": "Charg\u00e9",
    "columnStatus": "Statut",
    "time": {
      "justNow": "\u00c0 l\u2019instant",
      "minutesAgo": "il y a {{count}} min",
      "hoursAgo": "il y a {{count}} h",
      "daysAgo": "il y a {{count}} j"
    }
  },
  "agents": {
    "title": "Agents",
    "subtitle": "S\u00e9lectionnez un agent pour d\u00e9marrer une conversation",
    "searchPlaceholder": "Rechercher des agents par nom, mod\u00e8le ou capacit\u00e9...",
    "count_one": "{{count}} agent disponible",
    "count_other": "{{count}} agents disponibles",
    "loading": "Chargement des agents...",
    "error": "\u00c9chec du chargement des agents",
    "noAgentsFound": "Aucun agent trouv\u00e9",
    "noAgentsAvailable": "Aucun agent disponible",
    "adjustSearch": "Essayez d\u2019ajuster votre terme de recherche",
    "noAgentsConfigured": "Aucun agent IA n\u2019est actuellement configur\u00e9",
    "clickToChat": "Cliquez sur un agent pour d\u00e9marrer une conversation..."
  },
  "profile": {
    "title": "Profil",
    "subtitle": "G\u00e9rez les param\u00e8tres et pr\u00e9f\u00e9rences de votre compte",
    "loading": "Chargement du profil...",
    "updateSuccess": "Profil mis \u00e0 jour avec succ\u00e8s !",
    "firstName": "Pr\u00e9nom",
    "firstNamePlaceholder": "Saisir le pr\u00e9nom",
    "lastName": "Nom de famille",
    "lastNamePlaceholder": "Saisir le nom de famille",
    "email": "E-mail",
    "emailReadonly": "L\u2019e-mail ne peut pas \u00eatre modifi\u00e9",
    "emailCannotChange": "L\u2019e-mail ne peut pas \u00eatre modifi\u00e9. Contactez le support si vous devez le mettre \u00e0 jour.",
    "connectedVia": "Connect\u00e9 via {{provider}}",
    "notSet": "Non d\u00e9fini",
    "changePassword": "Changer le mot de passe",
    "currentPassword": "Mot de passe actuel",
    "currentPasswordPlaceholder": "Saisir le mot de passe actuel",
    "newPassword": "Nouveau mot de passe",
    "newPasswordPlaceholder": "Saisir le nouveau mot de passe",
    "newPasswordHint": "Doit contenir au moins 8 caract\u00e8res avec une majuscule, une minuscule, un chiffre et un caract\u00e8re sp\u00e9cial",
    "confirmPassword": "Confirmer le nouveau mot de passe",
    "confirmPasswordPlaceholder": "Confirmer le nouveau mot de passe",
    "changingPassword": "Changement du mot de passe...",
    "passwordSuccess": "Mot de passe chang\u00e9 avec succ\u00e8s !",
    "passwordMismatch": "Les nouveaux mots de passe ne correspondent pas",
    "passwordError": "\u00c9chec du changement de mot de passe",
    "edit": "Modifier",
    "saveError": "\u00c9chec de l\u2019enregistrement des modifications. Veuillez r\u00e9essayer.",
    "defaultOrganization": "Agion Platform",
    "validation": {
      "minLength": "Le mot de passe doit contenir au moins 8 caract\u00e8res",
      "complexity": "Le mot de passe doit contenir au moins un chiffre ou un caract\u00e8re sp\u00e9cial"
    },
    "providers": {
      "google": "Google",
      "microsoft": "Microsoft",
      "email": "E-mail et mot de passe",
      "agion": "Agion"
    }
  },
  "nextPages": {
    "aboutSection": "\u00c0 propos de {{subject}}",
    "files": {
      "actions": "Actions",
      "deleteTitle": "Supprimer {{name}} ?",
      "loadError": "Vos fichiers n'ont pas pu \u00eatre charg\u00e9s",
      "loadErrorBody": "Vos fichiers n'ont pas pu \u00eatre lus. R\u00e9essayez dans un instant.",
      "emptyTitle": "Aucun fichier pour le moment",
      "emptyBody": "Les fichiers que vous joignez \u00e0 l'ex\u00e9cution d'une mission apparaissent ici.",
      "moreActionsFor": "Plus d'actions pour {{name}}"
    },
    "profile": {
      "youTitle": "Vous",
      "youInfo": "Votre nom, votre e-mail et votre r\u00f4le dans cette organisation.",
      "role": "R\u00f4le",
      "preferencesTitle": "Pr\u00e9f\u00e9rences",
      "preferencesInfo": "La langue que le chat utilise pour vous.",
      "language": "Langue",
      "languageHint": "Enregistr\u00e9e dans votre compte : votre langue vous suit d'un navigateur \u00e0 l'autre.",
      "languageSaveFailed": "Votre langue n'a pas pu \u00eatre enregistr\u00e9e.",
      "passwordInfo": "Changez le mot de passe avec lequel vous vous connectez. Votre mot de passe actuel est n\u00e9cessaire.",
      "showPassword": "Afficher le mot de passe",
      "hidePassword": "Masquer le mot de passe",
      "loadError": "Votre profil n'a pas pu \u00eatre charg\u00e9",
      "loadErrorBody": "Les informations de votre compte n'ont pas pu \u00eatre lues. R\u00e9essayez dans un instant.",
      "openedBy": {
        "title": "Qui a ouvert vos conversations",
        "info": "Les personnes qui ont ouvert ou export\u00e9 le contenu d\u2019une conversation que vous avez lanc\u00e9e, les plus r\u00e9centes d\u2019abord.",
        "loading": "Chargement de qui a ouvert vos conversations\u2026",
        "loadError": "Impossible de charger qui a ouvert vos conversations",
        "empty": "Personne d\u2019autre n\u2019a ouvert vos conversations.",
        "showMore": "Afficher plus",
        "who": "{{name}} ({{role}})",
        "formerMember": "Un ancien membre",
        "unnamedMember": "Un membre de votre organisation",
        "read": "{{who}} a ouvert votre conversation {{mission}} le {{date}}",
        "export": "{{who}} a export\u00e9 votre conversation {{mission}} le {{date}}"
      }
    }
  }
}
